/* Smart-search: maakt de native Shopify-search slim zonder externe dienst (geen Clerk/Algolia).
 * - typefout-correctie (fuzzy tegen het catalogus-vocabulaire)
 * - volksmond -> catalogusterm (gympen->sneaker, sloffen->slipper, black->zwart)
 * - merk/categorie-redirects (zoekterm -> collectiepagina)
 * Werkt door /search/suggest.json en /search-queries te herschrijven via een fetch-interceptor.
 * Woordenboek: assets/search-dictionary.json (search_dictionary.py).
 */
(function () {
  "use strict";
  var DICT = null;
  var VOCAB = [];

  if (window.__smartSearchDict) {
    fetch(window.__smartSearchDict, { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (d) { DICT = d; VOCAB = d.vocab || []; })
      .catch(function () { DICT = null; });
  }

  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    var prev = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      var cur = [i];
      for (j = 1; j <= n; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      }
      prev = cur;
    }
    return prev[n];
  }

  function canon(word) {
    if (!DICT || !DICT.synonyms) return word;
    return DICT.synonyms[word] || word;
  }

  var STOP = { voor: 1, de: 1, het: 1, een: 1, en: 1, van: 1, met: 1, op: 1, in: 1, om: 1,
    te: 1, je: 1, mijn: 1, ook: 1, naar: 1, bij: 1, dan: 1, of: 1, off: 1, the: 1, for: 1,
    aan: 1, uit: 1, per: 1, als: 1, dat: 1, dit: 1, die: 1 };

  function correct(word) {
    if (/^\d+$/.test(word)) return word;          // artikelnummers nooit "corrigeren"
    if (word.length < 4 || STOP[word]) return word;
    if (VOCAB.indexOf(word) !== -1) return word;
    var best = null;
    for (var i = 0; i < VOCAB.length; i++) {
      var v = VOCAB[i];
      if (Math.abs(v.length - word.length) > 1) continue;
      if (lev(word, v) === 1) { best = v; break; }
    }
    return best || word;
  }

  // Letterlijke NL-vertaling van merknamen die klanten typen ("gouden goose" i.p.v.
  // "Golden Goose") -> per-woord synoniemen missen dit (adjacency), dus hier als
  // fase vóór de per-woord-verwerking op de volledige (lowercase) query.
  var BIGRAMS = { "goud goose": "golden goose", "gouden goose": "golden goose" };
  function fixBigrams(q) {
    for (var k in BIGRAMS) { if (q.indexOf(k) !== -1) q = q.split(k).join(BIGRAMS[k]); }
    return q;
  }

  function rewriteQuery(q) {
    if (!q) return q;
    // Al een opgebouwde seizoensclausule ("20-2026" OR ...) -> niet nog eens door de
    // typefout-/synoniemmolen halen (de theme-ajax haalt dezelfde URL opnieuw op).
    if (q.indexOf('"') !== -1 || q.indexOf("(") !== -1) return q;
    // EasyPOS-zoek (intern gebruik): 5 cijfers = artikelnummer zonder voorloopnul.
    // SKU's zijn 6 cijfers ("042192-38"), dus aanvullen tot 6 maakt hem vindbaar.
    var num = q.trim();
    if (/^\d{5}$/.test(num)) return "0" + num;
    if (!DICT) return q;
    var words = fixBigrams(q.toLowerCase()).split(/\s+/).filter(Boolean);
    var out = words.map(function (w) {
      if (STOP[w]) return w;
      return canon(correct(w));
    });
    return out.join(" ");
  }

  function correctOnly(q) {
    return (q || "").toLowerCase().trim().split(/\s+/).map(function (w) { return STOP[w] ? w : correct(w); }).join(" ");
  }

  // ---- Seizoen-zoeken ---------------------------------------------------------
  // Bezoekers zoeken op "winter 2026", "fw26", "najaarscollectie"; de catalogus kent
  // alleen de code WW-JJJJ (tag + metafield specs.seizoenscode). De storefront-search
  // kent exacte-frase-quotes en OR, dus ("20-2026" OR "21-2026") filtert precies op
  // seizoen en blijft combineerbaar met merk/categorie: ("20-2026" OR "21-2026") jas.
  // LET OP: /search/suggest.json kent die syntax NIET (geeft 0 resultaten) -> in de
  // preview-dropdown alleen de restwoorden gebruiken, nooit de clausule.
  var SEIZOEN_WOORD = {
    winter: "fw", herfst: "fw", najaar: "fw", herfstwinter: "fw", winters: "fw",
    fall: "fw", autumn: "fw", herbst: "fw",
    zomer: "ss", lente: "ss", voorjaar: "ss", zomers: "ss",
    summer: "ss", spring: "ss", sommer: "ss", "fr\u00fchling": "ss", fruhling: "ss"
  };
  // "wintercollectie", "najaarscollectie", "sommerkollektion", ...
  var SEIZOEN_SUFFIX = /^(.+?)(collectie|kollektion|collection|seizoen|season)$/;
  var COLLECTIE_WOORD = { collectie: 1, kollektion: 1, collection: 1, seizoen: 1, season: 1 };
  var NIEUW_WOORD = { nieuw: 1, nieuwe: 1, new: 1, neu: 1, neue: 1 };
  var CODE_RE = /^(fw|aw|hw|ss|sv|va)[\s-]?(\d{2}|\d{4})$/;   // fw26, aw-2026, ss 27
  var RAWCODE_RE = /^\d{1,2}-\d{4}$/;                          // 20-2026

  function seasonGroups() { return (DICT && DICT.seasons && DICT.seasons.groups) || null; }

  function pickGroup(type, jaar) {
    var G = seasonGroups(); if (!G) return null;
    if (jaar && G[type + "-" + jaar]) return type + "-" + jaar;
    if (jaar) {
      // gevraagd jaar bestaat niet (bv. "winter 2028") -> dichtstbijzijnde seizoen van
      // hetzelfde type, zodat de bezoeker iets ziet i.p.v. nul resultaten.
      var best = null, d = 99;
      for (var k in G) {
        if (G[k].type !== type) continue;
        var dd = Math.abs(G[k].jaar - jaar);
        if (dd < d) { d = dd; best = k; }
      }
      return best;
    }
    return (DICT.seasons.default || {})[type] || null;
  }

  // Ontleedt de woorden; geeft {key, group, rest} of null.
  function detectSeason(words) {
    var G = seasonGroups(); if (!G) return null;
    var used = {}, type = null, jaar = null, jaarIdx = -1, key = null, nieuwIdx = [];
    var expliciet = false, collectie = false, nieuw = false, hits = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i].toLowerCase().replace(/[.,!?]/g, "");
      if (!w) continue;
      if (RAWCODE_RE.test(w) && DICT.seasons.codes && DICT.seasons.codes[w]) {
        key = DICT.seasons.codes[w]; expliciet = true; used[i] = 1; hits++; continue;
      }
      var m = w.match(CODE_RE);
      if (m) {
        type = (m[1] === "ss" || m[1] === "sv" || m[1] === "va") ? "ss" : "fw";
        jaar = m[2].length === 4 ? +m[2] : 2000 + (+m[2]);
        expliciet = true; used[i] = 1; hits++; continue;
      }
      if (SEIZOEN_WOORD[w]) { type = SEIZOEN_WOORD[w]; used[i] = 1; hits++; continue; }
      var sm = w.match(SEIZOEN_SUFFIX);
      if (sm) {
        // "najaarscollectie" -> stam "najaars"; de tussen-s hoort niet bij het woord
        var stam = SEIZOEN_WOORD[sm[1]] ? sm[1] : sm[1].replace(/s$/, "");
        if (SEIZOEN_WOORD[stam]) { type = SEIZOEN_WOORD[stam]; collectie = true; used[i] = 1; hits++; continue; }
      }
      if (COLLECTIE_WOORD[w]) { collectie = true; used[i] = 1; hits++; continue; }
      if (NIEUW_WOORD[w]) { nieuw = true; nieuwIdx.push(i); continue; }  // pas opeten bij "nieuwe collectie"
      if (/^20\d\d$/.test(w)) { jaar = +w; jaarIdx = i; continue; } // pas opeten als er een seizoen is
      if (/^'\d{2}$/.test(w)) { jaar = 2000 + (+w.slice(1)); jaarIdx = i; continue; }
    }
    if (!key) {
      if (!type) {
        // "nieuwe collectie" zonder seizoenswoord -> het nieuwste seizoen
        if (nieuw && collectie) {
          key = (DICT.seasons.default || {}).nieuw || null;
          if (key) for (var ni = 0; ni < nieuwIdx.length; ni++) used[nieuwIdx[ni]] = 1;
        }
        if (!key) return null;
      } else {
        // Alleen een seizoenswoord ("winter jas") is te dun: "winter" is dan een
        // producteigenschap, geen seizoen. Vereis een jaartal, het woord "collectie",
        // een expliciete code, of een vraag die uit niets anders bestaat.
        if (!(expliciet || jaar || collectie || hits === words.length)) return null;
        key = pickGroup(type, jaar);
      }
    }
    var g = key && G[key];
    if (!g) return null;
    if (jaarIdx >= 0) used[jaarIdx] = 1;
    var rest = [];
    for (var j = 0; j < words.length; j++) if (!used[j]) rest.push(words[j]);
    return { key: key, group: g, rest: rest.join(" ") };
  }


  // Vangnet tegen een redirect-lus: mocht het thema de quotes ooit uit de URL strippen,
  // dan mag dezelfde zoekterm hooguit een keer per sessie omgeleid worden.
  function seasonRedirectDone(q) {
    try { return sessionStorage.getItem("eq_season_rd") === (q || "").toLowerCase(); } catch (e) { return false; }
  }
  function markSeasonRedirect(q) {
    try { sessionStorage.setItem("eq_season_rd", (q || "").toLowerCase()); } catch (e) { }
  }

  function seasonClause(g) {
    var out = [];
    for (var i = 0; i < g.codes.length; i++) out.push('"' + g.codes[i] + '"');
    return "(" + out.join(" OR ") + ")";
  }

  // Volledige zoekopdracht voor de resultatenpagina: clausule VOORAAN (levert meer
  // treffers dan achteraan) + de gewoon-herschreven restwoorden.
  function seasonQuery(hit) {
    var rest = hit.rest ? rewriteQuery(hit.rest) : "";
    return rest ? seasonClause(hit.group) + " " + rest : seasonClause(hit.group);
  }

  function seasonHit(q) {
    if (!DICT || !DICT.seasons) return null;
    // "fw 26" / "ss 2026" typen mensen met een spatie; eerst samenvoegen tot een code.
    var norm = fixBigrams((q || "").toLowerCase()).replace(/\b(fw|aw|hw|ss|sv|va)\s+(\d{2}|\d{4})\b/g, "$1$2");
    var words = norm.split(/\s+/).filter(Boolean);
    if (!words.length) return null;
    try { return detectSeason(words); } catch (e) { return null; }
  }

  // ---- seizoenschip: laat zien DAT er op seizoen gefilterd is, met een uitweg -------
  (function () {
    var st = document.createElement("style");
    st.textContent =
      ".smart-season{display:flex;align-items:center;gap:10px;flex-wrap:wrap;width:100%;flex:0 0 100%;max-width:1100px;margin:14px auto 0;padding:0 20px;box-sizing:border-box}" +
      ".smart-season__chip{display:inline-flex;align-items:center;gap:8px;padding:7px 8px 7px 14px;border-radius:999px;" +
      "background:#137a6b;color:#fff;font-size:14px;line-height:1;text-decoration:none}" +
      ".smart-season__x{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;" +
      "background:rgba(255,255,255,.22);color:#fff;text-decoration:none;font-size:13px;line-height:1}" +
      ".smart-season__x:hover{background:rgba(255,255,255,.38)}" +
      ".smart-season__note{font-size:13px;opacity:.6}";
    document.head.appendChild(st);
  })();


  // De chip MOET buiten de resultaten-container blijven: `.product-facet` is een flexbox
  // (aside 265px + main flex:1). Een extra kind daarin wordt een derde flex-item en duwt
  // de filters naar het midden en de producten samen tegen de rand — precies wat er
  // 25-8-2026 misging. Dus: als sibling ervoor, en nooit prependen in een flex/grid.
  function magPrepend(el) {
    try {
      var d = getComputedStyle(el).display;
      return d !== "flex" && d !== "grid" && d !== "inline-flex" && d !== "inline-grid";
    } catch (e) { return true; }
  }

  function plaatsChip(bar) {
    var facet = document.querySelector("product-facet, .product-facet");
    if (facet && facet.parentElement && magPrepend(facet.parentElement)) {
      facet.parentElement.insertBefore(bar, facet);
      return true;
    }
    var cat = document.querySelector(".main-search__category-result, .main-search__results");
    if (cat && magPrepend(cat)) { cat.insertBefore(bar, cat.firstChild); return true; }
    var h = document.querySelector(".search__title, #main-search h1, main h1");
    if (h && h.parentElement && magPrepend(h.parentElement)) {
      h.parentElement.insertBefore(bar, h.nextSibling);
      return true;
    }
    return false;
  }

  function renderSeasonChip() {
    try {
      var params = new URLSearchParams(location.search);
      var key = params.get("sq");
      if (!key || document.querySelector(".smart-season")) return;
      var g = seasonGroups() && seasonGroups()[key];
      if (!g) return;
      var zonder = params.get("dq") || "";
      var rest = "";
      var hit = seasonHit(zonder);
      if (hit && hit.rest) rest = hit.rest;
      // "kruisje" = dezelfde vraag zonder het seizoen; niets over -> terug naar alles
      var uit = rest ? ("/search?q=" + encodeURIComponent(rewriteQuery(rest)) + "&type=product&dq=" + encodeURIComponent(rest))
                     : "/collections/all";
      var bar = document.createElement("div");
      bar.className = "smart-season";
      bar.innerHTML = '<span class="smart-season__chip">' + g.label + " \u00b7 " + g.kort +
        '<a class="smart-season__x" href="' + uit + '" aria-label="Seizoensfilter verwijderen">\u00d7</a></span>' +
        '<span class="smart-season__note">Alleen artikelen uit deze collectie</span>';
      plaatsChip(bar);
    } catch (e) { }
  }
  document.addEventListener("DOMContentLoaded", function () {
    if (location.pathname.indexOf("/search") !== 0) return;
    var t = setInterval(function () { if (DICT) { clearInterval(t); renderSeasonChip(); } }, 150);
    setTimeout(function () { clearInterval(t); }, 4000);
    // Het thema hertekent de resultaten via ajax bij filteren/sorteren; zet de chip dan terug.
    try {
      if (!window.MutationObserver) return;
      var bezig = false;
      new MutationObserver(function () {
        if (bezig || !new URLSearchParams(location.search).get("sq")) return;
        if (document.querySelector(".smart-season")) return;
        bezig = true;
        setTimeout(function () { bezig = false; renderSeasonChip(); }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) { }
  });

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var u = typeof input === "string" ? input : (input && input.url);
      if (u && /\/search\/suggest(\.json)?|\/search\?/.test(u) && u.indexOf("q=") !== -1) {
        var newU = u;
        var m = newU.match(/([?&]q=)([^&]*)/);
        if (m) {
          var raw = decodeURIComponent(m[2].replace(/\+/g, " "));
          // suggest.json snapt quotes/OR niet; daar dus alleen de niet-seizoenswoorden
          // ("winter 2026 jas" -> "jas"), zodat de preview toch iets zinnigs toont.
          var _sh = /\/search\/suggest/.test(newU) ? seasonHit(raw) : null;
          var nw = (_sh && _sh.rest) ? rewriteQuery(_sh.rest) : rewriteQuery(raw);
          if (nw && nw !== raw.toLowerCase()) {
            newU = newU.replace(/([?&]q=)([^&]*)/, m[1] + encodeURIComponent(nw));
          }
        }
        // Preview (suggest.json) doorzoekt standaard geen variant-SKU's; daardoor gaf
        // zoeken op een EasyPOS-nummer (042192) wel resultaat op ENTER maar niets in
        // de preview. fields expliciet meesturen lost dat op (incl. barcode = EAN).
        if (/\/search\/suggest/.test(newU) && newU.indexOf("%5Bfields%5D") === -1 && newU.indexOf("[fields]") === -1) {
          newU += "&resources%5Boptions%5D%5Bfields%5D=" +
                  encodeURIComponent("title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag");
        }
        // Alleen op de resultatenpagina: /search/suggest heeft de clausule juist niet.
        if (!/\/search\/suggest/.test(newU)) newU = herstelSeizoen(newU);
        if (newU !== u) {
          if (typeof input === "string") input = newU;
          else input = new Request(newU, input);
        }
      }
    } catch (e) { }
    return _fetch.call(this, input, init);
  };


  // Een doorverwijzing is óf een collectie-handle ("ugg") óf een letterlijk pad
  // ("/pages/ruilen-retourneren"). Dat tweede maakt het mogelijk servicevragen te
  // beantwoorden: de zoekbalk staat op type=product en vindt dus nooit een pagina.
  function doelUrl(target) {
    return target.charAt(0) === "/" ? target : "/collections/" + target;
  }


  // Het thema bouwt bij elke filter- of sorteeractie de zoek-URL opnieuw op uit het
  // ZOEKINVOERVELD, niet uit de URL. Dat veld toont bewust de leesbare vraag
  // ("fw26 sneakers", zie de dq-parameter), dus de seizoensclausule verdween bij de
  // eerste de beste filterklik en het filter leverde daardoor de verkeerde set.
  // Hier zetten we de clausule terug op elk /search-verzoek zolang de pagina een
  // seizoen toont (sq in de URL).
  function herstelSeizoen(u) {
    try {
      if (!DICT || !DICT.seasons) return u;
      var key = new URLSearchParams(location.search).get("sq");
      if (!key) return u;
      var g = (DICT.seasons.groups || {})[key];
      if (!g) return u;
      var m = u.match(/([?&]q=)([^&]*)/);
      if (!m) return u;
      var q = decodeURIComponent(m[2].replace(/\+/g, " "));
      if (q.indexOf('"') !== -1) return u;          // clausule staat er al
      // seasonQuery() haalt de restwoorden zelf door het woordenboek ("sneakers"
      // -> "sneaker"); hit.rest rauw gebruiken zou een andere set opleveren dan de
      // oorspronkelijke zoekopdracht.
      var hit = seasonHit(q);
      var nieuw = hit ? seasonQuery(hit)
                      : seasonClause(g) + (rewriteQuery(q) ? " " + rewriteQuery(q) : "");
      return u.replace(/([?&]q=)([^&]*)/, m[1] + encodeURIComponent(nieuw));
    } catch (e) { return u; }
  }

  function tagSearchSource(form) {
    try { sessionStorage.setItem("eq_search_source", form.classList.contains("mm-search") ? "mobile_menu" : "header"); } catch (e) {}
  }
  function readSearchSource() {
    try {
      var s = sessionStorage.getItem("eq_search_source");
      sessionStorage.removeItem("eq_search_source");
      return s || "unknown";
    } catch (e) { return "unknown"; }
  }

  document.addEventListener("submit", function (ev) {
    try {
      var form = ev.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/search") === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !DICT) return;
      var raw = input.value.trim();
      if (!raw) return;
      pushRecent(raw);
      tagSearchSource(form);
      var low = raw.toLowerCase();
      var rw = rewriteQuery(raw);
      var target = (DICT.redirects || {})[low] || (DICT.redirects || {})[rw];
      if (target) {
        ev.preventDefault();
        track({ type: "search", q: raw, redirected_to: target, query_id: newId(), client_id: clientId(), source: readSearchSource() });
        window.location.href = doelUrl(target);
        return;
      }
      ev.preventDefault();
      var hit = seasonHit(raw);
      if (hit) {
        var su = "/search?q=" + encodeURIComponent(seasonQuery(hit)) + "&type=product" +
                 "&dq=" + encodeURIComponent(raw) + "&sq=" + encodeURIComponent(hit.key);
        track({ type: "search", q: raw, season: hit.key, query_id: newId(), client_id: clientId(), source: readSearchSource() });
        window.location.href = su;
        return;
      }
      var u = "/search?q=" + encodeURIComponent(rw || raw) + "&type=product";
      if (rw && rw !== low) u += "&dq=" + encodeURIComponent(raw);
      window.location.href = u;
    } catch (e) { }
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (location.pathname.indexOf("/search") !== 0) return;
      var params = new URLSearchParams(location.search);
      var q = (params.get("q") || "").trim();
      if (!q) return;
      var dq = params.get("dq");
      if (dq) {
        var _in = document.querySelectorAll('input[name="q"]');
        for (var ii = 0; ii < _in.length; ii++) _in[ii].value = dq;
        var _esc = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        var _h = document.querySelectorAll("h1, .search__title, .heading");
        for (var hi = 0; hi < _h.length; hi++) {
          var el = _h[hi];
          if (el.children.length === 0 && el.textContent && el.textContent.toLowerCase().indexOf(q.toLowerCase()) !== -1) {
            el.textContent = el.textContent.replace(new RegExp(_esc, "i"), dq);
          }
        }
      }
      var wait = setInterval(function () {
        if (!DICT) return;
        clearInterval(wait);
        var low = q.toLowerCase();
        var target = (DICT.redirects || {})[low];
        if (target) {
          track({ type: "search", q: q, redirected_to: target, client_id: clientId(), source: readSearchSource() });
          location.replace(doelUrl(target));
          return;
        }
        // Rechtstreeks op /search?q=winter+2026 beland (link, bookmark, of het thema
        // ving de submit zelf af) -> alsnog naar de seizoensvorm.
        if (!params.get("sq") && q.indexOf('"') === -1 && !seasonRedirectDone(q)) {
          var shit = seasonHit(q);
          if (shit) {
            markSeasonRedirect(q);
            params.set("q", seasonQuery(shit));
            params.set("type", "product");
            params.set("dq", q);
            params.set("sq", shit.key);
            location.replace(location.pathname + "?" + params.toString());
            return;
          }
        }
        var rw = rewriteQuery(q);
        var geen = /geen resultaten|no results/i.test(document.body.innerText || "");
        if (rw && rw !== low && geen) {
          params.set("q", rw);
          params.set("type", "product");
          location.replace(location.pathname + "?" + params.toString());
        }
      }, 150);
      setTimeout(function () { clearInterval(wait); }, 4000);
    } catch (e) { }
  });

  var SUGG = [];
  if (window.__smartSearchSuggest) {
    fetch(window.__smartSearchSuggest, { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (d) { SUGG = d || []; })
      .catch(function () { SUGG = []; });
  }

  (function () {
    var s = document.createElement("style");
    s.textContent =
      ".smart-suggestions{padding:12px 0 4px}" +
      ".smart-suggestions__title{font-size:11px;letter-spacing:.08em;text-transform:uppercase;opacity:.55;margin:0 0 6px}" +
      ".smart-suggestions ul{list-style:none;margin:0;padding:0}" +
      ".smart-suggestions li{margin:0}" +
      ".smart-suggestions a{display:flex;align-items:center;gap:8px;padding:9px 2px;color:inherit;text-decoration:none;font-size:15px;border-bottom:1px solid rgba(0,0,0,.06)}" +
      ".smart-suggestions a:before{content:'';width:14px;height:14px;flex:0 0 auto;opacity:.4;background:no-repeat center/contain url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2'%3E%3Ccircle cx='11' cy='11' r='7'/%3E%3Cpath d='m21 21-4.3-4.3'/%3E%3C/svg%3E\")}" +
      ".smart-suggestions__label{display:inline}" +
      ".smart-dd{position:absolute;left:0;right:0;top:calc(100% + 6px);background:#fff;z-index:70;box-shadow:0 12px 34px rgba(0,0,0,.14);border-radius:10px;max-height:60vh;overflow:auto;padding:2px 16px}" +
      ".smart-suggestions b{font-weight:700;color:#137a6b}";
    document.head.appendChild(s);
  })();

  function matchSugg(q) {
    q = (q || "").toLowerCase().trim();
    if (q.length < 2 || !SUGG.length) return [];
    var words = q.split(/\s+/).map(function (w) { return STOP[w] ? w : correct(w); });
    var res = [];
    for (var i = 0; i < SUGG.length && res.length < 6; i++) {
      var lab = SUGG[i].match, ok = true;
      for (var w = 0; w < words.length; w++) { if (lab.indexOf(words[w]) === -1) { ok = false; break; } }
      if (ok) res.push(SUGG[i]);
    }
    return res;
  }

  function drawerWrap(input) {
    var d = input.closest("predictive-search-drawer, #search-drawer, .predictive-search");
    return d ? d.querySelector(".predictive-search__content-wrapper") : null;
  }
  function suggBox(input) {
    var wrap = drawerWrap(input);
    if (wrap) {
      var b = wrap.querySelector(".smart-suggestions");
      if (!b) { b = document.createElement("div"); b.className = "smart-suggestions"; wrap.insertBefore(b, wrap.firstChild); }
      return b;
    }
    var host = input.closest("form") || input.parentElement;
    if (!host) return null;
    var dd = host.querySelector(".smart-dd");
    if (!dd) { dd = document.createElement("div"); dd.className = "smart-dd smart-suggestions"; host.style.position = "relative"; host.appendChild(dd); }
    return dd;
  }

  function renderSugg(input) {
    var box = suggBox(input);
    if (!box) return;
    var q = input.value.toLowerCase().trim();
    var corrected = correctOnly(q);
    var items = matchSugg(input.value);
    var dym = (corrected && corrected !== q) ? corrected : "";
    if (!items.length && !dym && !seasonHit(input.value)) { box.innerHTML = ""; box.style.display = "none"; return; }
    var esc = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var html = '<p class="smart-suggestions__title">Suggesties</p><ul>';
    // Seizoensvraag herkend -> als eerste regel de directe route naar dat seizoen; de
    // productpreview eronder komt van suggest.json, die de seizoensyntax niet kent.
    var shit = seasonHit(input.value);
    if (shit) {
      var surl = "/search?q=" + encodeURIComponent(seasonQuery(shit)) + "&type=product" +
                 "&dq=" + encodeURIComponent(input.value.trim()) + "&sq=" + encodeURIComponent(shit.key);
      html += '<li><a href="' + surl + '"><span class="smart-suggestions__label"><b>' +
              shit.group.label + "</b> \u00b7 " + shit.group.kort +
              (shit.rest ? " \u00b7 " + shit.rest : "") + "</span></a></li>";
    }
    if (dym) {
      html += '<li><a href="/search?q=' + encodeURIComponent(corrected) + '&type=product">Bedoelde je <span class="smart-suggestions__label"><b>' + corrected + "</b></span>?</a></li>";
    }
    items.forEach(function (s) {
      var label = s.label.replace(new RegExp("(" + esc + ")", "i"), "<b>$1</b>");
      html += '<li><a href="/search?q=' + encodeURIComponent(s.q) + '&type=product"><span class="smart-suggestions__label">' + label + "</span></a></li>";
    });
    html += "</ul>";
    box.innerHTML = html;
    box.style.display = "block";
  }

  var POPULAR = [
    { l: "Sneakers", u: "/search?q=sneakers" }, { l: "Laarzen", u: "/search?q=laarzen" },
    { l: "Sale", u: "/collections/summersale" }, { l: "Loafers", u: "/search?q=loafers" },
    { l: "Stone Island", u: "/collections/stone-island" }, { l: "UGG", u: "/collections/ugg" },
    { l: "Golden Goose", u: "/collections/golden-goose" }, { l: "Woolrich", u: "/collections/woolrich" },
    { l: "Moncler", u: "/collections/moncler" }, { l: "Autry", u: "/collections/autry" }
  ];
  function recent() { try { return JSON.parse(localStorage.getItem("eq_recent_search") || "[]"); } catch (e) { return []; } }
  function pushRecent(q) {
    try { q = (q || "").trim(); if (!q) return;
      var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q); localStorage.setItem("eq_recent_search", JSON.stringify(r.slice(0, 6)));
    } catch (e) { }
  }
  function chipsHtml(items, title, isRecent) {
    if (!items || !items.length) return "";
    var h = '<div class="smart-pop__group"><p class="smart-suggestions__title">' + title + '</p><div class="smart-pop__chips">';
    items.forEach(function (it) {
      var label = isRecent ? it : it.l;
      var url = isRecent ? ("/search?q=" + encodeURIComponent(it) + "&type=product") : it.u;
      if (!isRecent && url.indexOf("/search") === 0 && url.indexOf("type=") === -1) url += "&type=product";
      h += '<a class="smart-pop__chip" href="' + url + '">' + label + "</a>";
    });
    return h + "</div></div>";
  }
  function renderEmpty(wrap) {
    if (!wrap) return;
    var box = wrap.querySelector(".smart-pop");
    if (!box) { box = document.createElement("div"); box.className = "smart-pop"; wrap.insertBefore(box, wrap.firstChild); }
    box.innerHTML = chipsHtml(recent(), "Recent gezocht", true) + chipsHtml(POPULAR, "Populair", false);
    box.style.display = "block";
    wrap.classList.add("has-smart-pop");
  }
  function clearEmpty(wrap) {
    if (!wrap) return;
    var box = wrap.querySelector(".smart-pop"); if (box) box.style.display = "none";
    wrap.classList.remove("has-smart-pop");
  }
  (function () {
    var s = document.createElement("style");
    s.textContent =
      ".smart-pop{padding:14px 0 2px}.smart-pop__group{margin-bottom:16px}" +
      ".smart-pop__chips{display:flex;flex-wrap:wrap;gap:8px}" +
      ".smart-pop__chip{display:inline-block;padding:8px 14px;border:1px solid rgba(0,0,0,.14);border-radius:999px;font-size:14px;color:inherit;text-decoration:none;line-height:1;transition:background .15s}" +
      ".smart-pop__chip:hover,.smart-pop__chip:active{background:rgba(0,0,0,.05)}" +
      ".has-smart-pop .predictive-search__menu-list{opacity:.6}" +
      ".has-smart-pop .predictive-search__menu-title{font-size:11px}";
    document.head.appendChild(s);
  })();

  // ---- lege resultatenpagina: bestsellers + populaire categorieën i.p.v. een dode
  // eindpunt, zodat een bezoeker die niets vindt toch verder kan bladeren. ----
  (function () {
    var s = document.createElement("style");
    s.textContent =
      ".smart-empty-help{max-width:1100px;margin:28px auto 0;padding:0 20px}" +
      ".smart-empty-help__title{font-size:11px;letter-spacing:.08em;text-transform:uppercase;opacity:.55;margin:0 0 10px}" +
      ".smart-empty-help__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:16px;margin-top:8px}" +
      ".smart-empty-help__card{display:block;text-decoration:none;color:inherit}" +
      ".smart-empty-help__img{aspect-ratio:3/4;background:#f4f4f4;border-radius:8px;overflow:hidden;margin-bottom:8px}" +
      ".smart-empty-help__img img{width:100%;height:100%;object-fit:cover;display:block}" +
      ".smart-empty-help__name{font-size:13px;font-weight:600;line-height:1.3}" +
      ".smart-empty-help__price{font-size:12px;color:#6b7280;margin-top:2px}";
    document.head.appendChild(s);
  })();
  function renderEmptyResultsHelp() {
    try {
      var host = document.querySelector(".empty-state");
      if (!host || document.querySelector(".smart-empty-help")) return;
      var box = document.createElement("div");
      box.className = "smart-empty-help";
      box.innerHTML = '<p class="smart-empty-help__title">Misschien vind je dit interessant</p>' + chipsHtml(POPULAR, "Populaire categorieën", false);
      host.parentElement.insertBefore(box, host.nextSibling);
      fetch("/collections/bestsellers/products.json?limit=8", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var products = d && d.products || [];
          if (!products.length) return;
          var grid = document.createElement("div");
          grid.className = "smart-empty-help__grid";
          products.forEach(function (p) {
            var img = p.images && p.images[0] && p.images[0].src;
            var price = p.variants && p.variants[0] && p.variants[0].price;
            var a = document.createElement("a");
            a.className = "smart-empty-help__card";
            a.href = "/products/" + p.handle;
            a.innerHTML = '<div class="smart-empty-help__img">' + (img ? '<img src="' + img + '&width=400" alt="" loading="lazy">' : "") + '</div>' +
              '<div class="smart-empty-help__name">' + p.title + '</div>' +
              (price ? '<div class="smart-empty-help__price">' + Number(price).toLocaleString("nl-NL", { style: "currency", currency: "EUR" }) + '</div>' : "");
            grid.appendChild(a);
          });
          var title = document.createElement("p");
          title.className = "smart-empty-help__title";
          title.style.marginTop = "22px";
          title.textContent = "Bestsellers";
          box.appendChild(title);
          box.appendChild(grid);
        })
        .catch(function () { });
    } catch (e) { }
  }

  function toggle(input) {
    var inDrawer = drawerWrap(input);
    if ((input.value || "").trim()) {
      if (inDrawer) clearEmpty(inDrawer);
      renderSugg(input);
    } else {
      var b = suggBox(input); if (b) { b.innerHTML = ""; b.style.display = "none"; }
      if (inDrawer) renderEmpty(inDrawer);
    }
  }
  document.addEventListener("click", function (ev) {
    var t = ev.target;
    if (t.closest && (t.closest(".smart-dd") || t.closest("form[action*='/search']") ||
        (t.getAttribute && t.getAttribute("name") === "q"))) return;
    var dds = document.querySelectorAll(".smart-dd");
    for (var i = 0; i < dds.length; i++) dds[i].style.display = "none";
  });
  document.addEventListener("input", function (ev) {
    var t = ev.target;
    if (t && t.getAttribute && t.getAttribute("name") === "q") { toggle(t); }
  });
  document.addEventListener("focusin", function (ev) {
    var t = ev.target;
    if (t && t.getAttribute && t.getAttribute("name") === "q" && !(t.value || "").trim()) { toggle(t); }
  });

  function track(ev) {
    try {
      if (!window.__searchTrackUrl) return;
      ev.t = Date.now();
      ev.path = location.pathname;
      var body = JSON.stringify(ev);
      if (navigator.sendBeacon) navigator.sendBeacon(window.__searchTrackUrl, body);
      else fetch(window.__searchTrackUrl, { method: "POST", body: body, keepalive: true, mode: "no-cors" });
    } catch (e) { }
  }

  function clientId() {
    try {
      var id = localStorage.getItem("eq_client_id");
      if (!id) {
        id = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2));
        localStorage.setItem("eq_client_id", id);
      }
      return id;
    } catch (e) { return ""; }
  }
  function newId() {
    return (crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2));
  }
  function resultItems() { return document.querySelectorAll(".product-item, [data-product-item-id]"); }
  function productIdOf(el) {
    var host = el.closest ? el.closest(".product-item, [data-product-item-id]") : null;
    return host ? (host.getAttribute("data-product-item-id") || "") : "";
  }

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (location.pathname.indexOf("/search") !== 0) return;
      var q = (new URLSearchParams(location.search).get("q") || "").trim();
      if (!q) return;
      var qid = newId();
      try { sessionStorage.setItem("eq_last_query_id", qid); } catch (e) {}
      var src = readSearchSource();
      var maxCount = 0, checks = 0;
      var poll = setInterval(function () {
        checks++;
        var items = resultItems();
        var c = items.length;
        if (c > maxCount) {
          maxCount = c;
          try {
            var ids = []; for (var i = 0; i < items.length && i < 60; i++) ids.push(items[i].getAttribute("data-product-item-id") || "");
            sessionStorage.setItem("eq_last_query_products", JSON.stringify(ids));
          } catch (e) {}
        }
        if (checks >= 12) {
          clearInterval(poll);
          var geen = maxCount === 0 && /geen resultaten|no results/i.test(document.body.innerText || "");
          // url = volledige querystring (incl. facetfilters) zodat een 0-resultaat-rapport kan
          // onderscheiden "term zelf levert niks op" van "term + filtercombinatie levert niks op".
          track({ type: "search", q: q, results: geen ? 0 : maxCount, query_id: qid, client_id: clientId(), source: src, url: location.search });
          if (geen) renderEmptyResultsHelp();
        }
      }, 400);
    } catch (e) { }
  });

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (location.pathname.indexOf("/search") !== 0 || !window.__searchBoostsUrl) return;
      var q = (new URLSearchParams(location.search).get("q") || "").trim();
      if (!q) return;
      fetch(window.__searchBoostsUrl + "?q=" + encodeURIComponent(q), { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || (!d.pinned.length && !d.buried.length && !d.boosted.length)) return;
          var items = Array.prototype.slice.call(resultItems());
          if (!items.length) return;
          var parent = items[0].parentElement;
          if (!parent) return;
          var byId = {}; items.forEach(function (el) { byId[el.getAttribute("data-product-item-id")] = el; });
          var used = {}, order = [];
          [d.pinned, d.boosted].forEach(function (list) {
            list.forEach(function (id) { if (byId[id] && !used[id]) { order.push(byId[id]); used[id] = true; } });
          });
          items.forEach(function (el) {
            var id = el.getAttribute("data-product-item-id");
            if (!used[id] && d.buried.indexOf(id) === -1) { order.push(el); used[id] = true; }
          });
          d.buried.forEach(function (id) { if (byId[id] && !used[id]) { order.push(byId[id]); used[id] = true; } });
          order.forEach(function (el) { parent.appendChild(el); });
        })
        .catch(function () { });
    } catch (e) { }
  });

  document.addEventListener("click", function (ev) {
    try {
      var a = ev.target.closest && ev.target.closest("a[href]");
      if (!a) return;
      var onSearchPage = location.pathname.indexOf("/search") === 0;
      var inDropdown = a.closest(".predictive-search, .smart-suggestions, [data-section-type='search']");
      var inResultsGrid = onSearchPage && a.closest(".product-facet, .search__results, #main-search");
      if (!inDropdown && !inResultsGrid) return;
      var input = document.querySelector('.predictive-search__input, #main-search input[name="q"], input[name="q"]');
      var q = input ? input.value.trim() : (new URLSearchParams(location.search).get("q") || "");
      var evt = { type: "click", q: q, url: a.getAttribute("href"), client_id: clientId() };
      if (location.pathname.indexOf("/search") === 0) {
        try {
          evt.query_id = sessionStorage.getItem("eq_last_query_id") || undefined;
          var pid = productIdOf(a);
          if (pid) {
            evt.product_id = pid;
            var stored = JSON.parse(sessionStorage.getItem("eq_last_query_products") || "[]");
            var pos = stored.indexOf(pid);
            if (pos !== -1) evt.position = pos;
          }
        } catch (e) {}
      }
      track(evt);
    } catch (e) { }
  }, true);

  function adPageContext() {
    if (location.pathname.indexOf("/search") === 0) {
      var q = (new URLSearchParams(location.search).get("q") || "").trim();
      return q ? { context: "search", value: q, param: "q" } : null;
    }
    var m = location.pathname.match(/^\/collections\/([^\/?]+)/);
    if (m) return { context: "collection", value: m[1], param: "handle" };
    return null;
  }
  function trackAd(type, extra) {
    try {
      if (!window.__adEventUrl) return;
      var body = JSON.stringify(Object.assign({ type: type, t: Date.now(), client_id: clientId(), page_type: adPageContext() && adPageContext().context }, extra));
      if (navigator.sendBeacon) navigator.sendBeacon(window.__adEventUrl, body);
      else fetch(window.__adEventUrl, { method: "POST", body: body, keepalive: true, mode: "no-cors" });
    } catch (e) { }
  }

  var sponsoredMap = {};

  document.addEventListener("DOMContentLoaded", function () {
    try {
      var params = new URLSearchParams(location.search);
      var raw = params.get("eq_ad");
      if (!raw) return;
      var parts = raw.split(":");
      var campaignId = parts[0], productId = parts[1];
      if (!campaignId || !productId) return;
      var channel = params.get("eq_ch") || "external";
      trackAd("click", { campaign_id: campaignId, product_id: productId, context: channel, page_type: channel });
      var clicks = JSON.parse(sessionStorage.getItem("eq_ad_clicks") || "{}");
      clicks[productId] = { campaignId: campaignId, ts: Date.now() };
      Object.keys(clicks).forEach(function (k) { if (Date.now() - clicks[k].ts > 30 * 60 * 1000) delete clicks[k]; });
      sessionStorage.setItem("eq_ad_clicks", JSON.stringify(clicks));
      params.delete("eq_ad"); params.delete("eq_ch");
      var clean = location.pathname + (params.toString() ? "?" + params.toString() : "");
      history.replaceState(null, "", clean);
    } catch (e) { }
  });

  document.addEventListener("DOMContentLoaded", function () {
    try {
      var ctx = adPageContext();
      if (!ctx || !window.__adBoostsUrl) return;
      fetch(window.__adBoostsUrl + "?context=" + ctx.context + "&" + ctx.param + "=" + encodeURIComponent(ctx.value), { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (campaigns) {
          if (!campaigns || !campaigns.length) return;
          var items = Array.prototype.slice.call(resultItems());
          if (!items.length) return;
          var byId = {}; items.forEach(function (el) { byId[el.getAttribute("data-product-item-id")] = el; });
          var used = {}, order = [];
          campaigns.forEach(function (camp) {
            (camp.productIds || []).forEach(function (pid) {
              if (byId[pid] && !used[pid]) {
                sponsoredMap[pid] = camp.campaignId;
                used[pid] = true;
                order.push(byId[pid]);
              }
            });
          });
          if (!order.length) return;
          var parent = items[0].parentElement;
          if (!parent) return;
          items.forEach(function (el) { if (!used[el.getAttribute("data-product-item-id")]) order.push(el); });
          order.forEach(function (el) { parent.appendChild(el); });

          if (window.IntersectionObserver) {
            var seen = {};
            var obs = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var pid = entry.target.getAttribute("data-product-item-id");
                if (seen[pid]) return;
                seen[pid] = true;
                obs.unobserve(entry.target);
                trackAd("impression", { campaign_id: sponsoredMap[pid], product_id: pid, context: ctx.value });
              });
            }, { threshold: 0.5 });
            Object.keys(sponsoredMap).forEach(function (pid) { if (byId[pid]) obs.observe(byId[pid]); });
          }
        })
        .catch(function () { });
    } catch (e) { }
  });

  document.addEventListener("click", function (ev) {
    try {
      var a = ev.target.closest && ev.target.closest("a[href]");
      if (!a) return;
      var pid = productIdOf(a);
      if (!pid || !sponsoredMap[pid]) return;
      var ctx = adPageContext();
      trackAd("click", { campaign_id: sponsoredMap[pid], product_id: pid, context: ctx && ctx.value });
      var clicks = JSON.parse(sessionStorage.getItem("eq_ad_clicks") || "{}");
      clicks[pid] = { campaignId: sponsoredMap[pid], ts: Date.now() };
      Object.keys(clicks).forEach(function (k) { if (Date.now() - clicks[k].ts > 30 * 60 * 1000) delete clicks[k]; });
      sessionStorage.setItem("eq_ad_clicks", JSON.stringify(clicks));
    } catch (e) { }
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (location.pathname.indexOf("/products/") !== 0) return;
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      if (!forms.length) return;
      var clicks = JSON.parse(sessionStorage.getItem("eq_ad_clicks") || "{}");
      forms.forEach(function (f) {
        var m = (f.getAttribute("id") || "").match(/-(\d{6,})$/);
        var pid = m ? m[1] : null;
        if (!pid || !clicks[pid] || Date.now() - clicks[pid].ts > 30 * 60 * 1000) return;
        f.addEventListener("submit", function () {
          trackAd("add_to_cart", { campaign_id: clicks[pid].campaignId, product_id: pid });
        });
      });
    } catch (e) { }
  });

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (location.pathname !== "/" || !window.__adBoostsUrl) return;
      var box = document.getElementById("eq-spa-featured");
      var grid = box && box.querySelector(".eq-spa-featured__grid");
      if (!box || !grid) return;
      fetch(window.__adBoostsUrl + "?context=homepage", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (campaigns) {
          if (!campaigns || !campaigns.length) return;
          var handleToCampaign = {};
          campaigns.forEach(function (c) {
            (c.homepageHandles || []).forEach(function (h, i) {
              if (!handleToCampaign[h]) handleToCampaign[h] = { campaignId: c.campaignId, productId: (c.productIds || [])[i] || (c.productIds || [])[0] };
            });
          });
          var handles = Object.keys(handleToCampaign).slice(0, 4);
          if (!handles.length) return;
          Promise.all(handles.map(function (h) {
            return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          })).then(function (products) {
            var html = "";
            products.forEach(function (p, i) {
              if (!p) return;
              var h = handles[i], info = handleToCampaign[h];
              var img = p.featured_image || (p.images && p.images[0]) || "";
              var price = (p.price / 100).toLocaleString("nl-NL", { style: "currency", currency: "EUR" });
              var href = "/products/" + h + "?eq_ad=" + info.campaignId + ":" + info.productId + "&eq_ch=homepage";
              html += '<a href="' + href + '" data-eq-handle="' + h + '" style="text-decoration:none;color:inherit;display:block;max-width:280px">' +
                '<div style="aspect-ratio:1/1.2;background:#f4f4f4;border-radius:8px;overflow:hidden;margin-bottom:10px">' +
                (img ? '<img src="' + img + '&width=400" alt="" style="width:100%;height:100%;object-fit:cover">' : "") +
                "</div>" +
                '<div style="font-size:14px;font-weight:600;line-height:1.3">' + p.title + "</div>" +
                '<div style="font-size:13px;color:#6b7280;margin-top:2px">' + price + "</div>" +
                "</a>";
            });
            if (!html) return;
            grid.innerHTML = html;
            box.style.display = "block";
            if (window.IntersectionObserver) {
              var seen = {};
              var obs = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                  var h = entry.target.getAttribute("data-eq-handle");
                  if (!entry.isIntersecting || seen[h]) return;
                  seen[h] = true; obs.unobserve(entry.target);
                  var info = handleToCampaign[h];
                  trackAd("impression", { campaign_id: info.campaignId, product_id: info.productId, context: "homepage", page_type: "homepage" });
                });
              }, { threshold: 0.3 });
              grid.querySelectorAll("[data-eq-handle]").forEach(function (el) { obs.observe(el); });
            }
          });
        })
        .catch(function () { });
    } catch (e) { }
  });

  function ensureProductType() {
    try {
      document.querySelectorAll('form[action*="/search"]').forEach(function (f) {
        if (f.id === "predictive-search-form") return;
        if (f.querySelector('input[name="type"]')) return;
        var i = document.createElement("input");
        i.type = "hidden"; i.name = "type"; i.value = "product";
        f.appendChild(i);
      });
    } catch (e) { }
  }
  document.addEventListener("DOMContentLoaded", ensureProductType);
  document.addEventListener("focusin", function (ev) {
    var t = ev.target;
    if (t && t.getAttribute && t.getAttribute("name") === "q") ensureProductType();
  });

  // Testhaak: laat de seizoenslogica van buitenaf aanroepen (node-test + console-debug).
  try {
    window.__smartSearchDebug = {
      seasonHit: seasonHit, seasonQuery: seasonQuery, rewriteQuery: rewriteQuery,
      plaatsChip: plaatsChip, renderSeasonChip: renderSeasonChip, doelUrl: doelUrl,
      herstelSeizoen: herstelSeizoen,
      setDict: function (d) { DICT = d; VOCAB = (d && d.vocab) || []; }
    };
  } catch (e) { }
})();
